export default __webpack_public_path__ + "static/media/bg.7c7a1baf.jpg";